// Input variants: composite text inputs, resolved by part.
export const INPUT_VARIANTS = Object.freeze(["searchPill"]);

export const INPUT_PARTS = Object.freeze(["root", "icon", "input", "mic", "error"]);

export const INPUT_USE_CASES = Object.freeze({
  searchPill: "PWA app-bar search pill — 12px padding, 60px radius, searchStroke border on neutral.surface, leading search icon, trailing mic.",
});
